import type React from "react";

import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";

import { View } from "shared/containers/View";

import { ClinicPartnerInvitationTable, ClinicPartnerInvitePatient } from "./components";

export const ClinicPartnerInvitations: React.FC = () => {
  const { t } = useTranslation();

  return (
    <View title={t("views.invitations")} description={t("views.invitations_description")}>
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, lg: 8 }}>
          <ClinicPartnerInvitationTable />
        </Grid2>

        <Grid2 size={{ xs: 12, lg: 4 }} sx={{ minWidth: 320 }}>
          <ClinicPartnerInvitePatient />
        </Grid2>
      </Grid2>
    </View>
  );
};
